import styled from 'styled-components/macro';
import { Button } from '@yme/atoms/button';
import { colorCoreBackground1000, colorCoreGray500 } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { RegularTextLevel4 } from '@yme/tokens/typography';
export const WrapperStyled = styled.div `
  padding: 16px 0px 16px 0px;
  background-color: ${colorCoreBackground1000};
  border-bottom: 1px solid ${colorCoreGray500};
`;
export const DescriptionStyled = styled(RegularTextLevel4) `
  ${ADAPTIVE.minWidth.desktop} {
    max-width: 655px;
  }
`;
export const DropdownWrapperStyled = styled.div `
  ${ADAPTIVE.minWidth.tablet} {
    width: 100%;
  }

  ${ADAPTIVE.minWidth.desktop} {
    width: 190px;
    flex-shrink: 0;
  }
`;
export const ConfirmButtonStyled = styled(Button) `
  ${ADAPTIVE.minWidth.desktop} {
    width: auto;
  }

  ${ADAPTIVE.minWidth.desktopLg} {
    width: 190px;
  }
`;
